import { useForm } from "react-hook-form"
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import axios from 'axios';

const FormComment = () => {

    const schema = yup.object().shape({
        name: yup.string().required("پر کردن فیلد الزامی است"),
        email: yup.string().email().required('لطفا ایمیل را به صورت email@gmail.com وارد کنید'),
        title: yup.string().required("پرکردن فیلد الزامی است"),
        description: yup.string().required("پر کردن فیلد الزامی است"),
    })

    const { register, handleSubmit, formState: { errors } } = useForm({ mode: "all", resolver: yupResolver(schema) })

    const onFormSubmit = (data, e) => {
        console.log(data);

        axios({
            method: "post", url: "https://amirsabit.4api.ir/contact", data: data, headers: { "Content-Type": "multipart/form-data" }
        })

            .then(function (response) {
                console.log((response.data));
                e.target.reset();
                // alert(response.data.Message)
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    return (

        <div className="form-comment">
            <div className="block-title">
                <h6 className="title">چطور میتونم به شما کمک کنم؟</h6>
            </div>

            <form onSubmit={handleSubmit(onFormSubmit)}>

                <div className="row">
                    <div className="col-sm-6 ps-sm-2">
                        <div className="mb-3">
                            <input type="text" className="form-control" placeholder="نام..." {...register('name')} />
                            {errors.name && (<p className="tx-error">{errors.name?.message}</p>)}
                        </div>
                        <div className="mb-3">
                            <input type="email" className="form-control" placeholder="ایمیل..." {...register('email')} />
                            {errors.email && (<p className="tx-error">{errors.email?.message}</p>)}
                        </div>
                        <div className="mb-3">
                            <input type="text" className="form-control" id="" placeholder="موضوع *" {...register('title')} />
                            {errors.title && (<p className="tx-error">{errors.title?.message}</p>)}
                        </div>
                    </div>
                    <div className="col-sm-6 mb-3 pe-sm-2">
                        <textarea className="form-control" id="exampleForm" placeholder="متن کامنت *" rows="5.5" {...register('description')}></textarea>
                        {errors.description && (<p className="tx-error">{errors.description?.message}</p>)}
                    </div>
                </div>

                <div className="text-start">
                    <input type="submit" value={'ثبت'} className="btn-page" />
                </div>
            </form>
        </div>

    )
}
export default FormComment;